

 export const truncateText = (text, maxChars) => {
    if (!text) return "";
    return text.length > maxChars
      ? text.substring(0, maxChars) + "..."
      : text;
  };

 export  const getCharLimit = (smallSize,largeSize,isSmall) => {

    if (isSmall) return smallSize;
    return largeSize;
  };

export const normalizeAmount = (amount) => {
  if (amount === null || amount === undefined || amount === "") {
    return 0;
  }

  const numericAmount = Number(amount);

  if (Number.isNaN(numericAmount)) {
    return 0;
  }

  return numericAmount / 100;
};